export { default } from './AccordionDetails';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/AccordionDetails/index.js
// module id = 302
// module chunks = 0